module.exports = __webpack_public_path__ + "static/img/huashan.47d0964.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/serviceCenter/huashan.png
// module id = /RxS
// module chunks = 44